/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
    ERROR_BANK_AND_TAX_STATUS,
    ERROR_ENROLLMENTS,
    ERROR_METADATA,
    ERROR_PAYOUT_REPORTS,
    ERROR_INVITATIONS
} from "../actions/actions";
import { ErrorStatus } from "../enrollment-store/store";
import { Action } from "../actions/actions";

export function errorStatus(
    state: ErrorStatus = new ErrorStatus(),
    action: Action
): ErrorStatus {
    const newState = { ...state };
    switch (action.type) {
        case ERROR_BANK_AND_TAX_STATUS: {
            newState.bankAndTax = true;
            return newState;
        }
        case ERROR_PAYOUT_REPORTS: {
            newState.payoutReports = true;
            return newState;
        }
        case ERROR_INVITATIONS: {
            newState.invitation = true;
            return newState;
        }
        case ERROR_ENROLLMENTS: {
            newState.enrollment = true;
            return newState;
        }
        case ERROR_METADATA: {
            newState.metadata = true;
            return newState;
        }
        default:
            return state;
    }
}
